import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

let cache = null;
let inflight = null;
const listeners = new Set();

export const brandUrl = (kind, b) => (b?.[kind] ? `${API}/brand/${kind}?v=${encodeURIComponent(b[kind].updated_at || "")}` : null);

export async function refreshBrand() {
  try { cache = (await api.get("/brand")).data; } catch { cache = {}; }
  listeners.forEach(l => l(cache));
  return cache;
}

export function useBrand() {
  const [brand, setBrand] = useState(cache);
  useEffect(() => {
    listeners.add(setBrand);
    if (!cache && !inflight) inflight = refreshBrand().finally(() => { inflight = null; });
    return () => listeners.delete(setBrand);
  }, []);
  return brand || {};
}
